import { SearchQuery, Filter } from './searchQuery';

export class AssetSearchCriteria {
    serialNumber?: string;
    customer?: string;
    site?: string;
    typeCode?: string;
    country?: string;
    city?: string;
    orderNumber?: string;

    constructor(init?: Partial<AssetSearchCriteria>) {
        Object.assign(this, init);
    }

    toSearchQuery(): SearchQuery {
        const filters: Filter[] = [];

        if (this.serialNumber) {
            const serialNumbers = this.serialNumber.split(',').map(x => x.trim());
            filters.push(new Filter('asset.serialNumber', 'equals', serialNumbers));
        }

        if (this.customer) {
            filters.push(new Filter('registration.customer.parentId', 'equals', [this.customer]));
        }

        if (this.site) {
            filters.push(new Filter('registration.site.name', 'equals', [this.site]));
        }

        if (this.typeCode) {
            filters.push(new Filter('asset.productdefinition.typeCode', 'equals', [this.typeCode]));
        }

        if (this.country) {
            filters.push(new Filter('registration.site.country', 'equals', [this.country]));
        }

        if (this.city) {
            filters.push(new Filter('registration.site.city', 'equals', [this.city]));
        }

        if (this.orderNumber) {
            filters.push(new Filter('asset.salesOrder', 'equals', [this.orderNumber]));
        }

        return new SearchQuery(filters);
    }
}